import { type KnowledgeGraphSeedSource } from "@/shared/domain/admin/ChatDebugRecord";

/**
 * Human labels for each knowledge-graph seed source, and the fixed order groups
 * render in — the priority order `build_seed_terms` assembles them in upstream,
 * so the group that mattered most for ranking reads first.
 *
 * These live in their own module rather than beside the component that renders
 * them so `seedSourceParity.test.ts` can import the order without turning the
 * component file into a mixed exports module (react-refresh).
 */
export const SEED_SOURCE_LABEL: Record<KnowledgeGraphSeedSource, string> = {
  latest_user_message: "Latest user message",
  latest_assistant_message: "Latest assistant message",
  active_task_title: "Active task — title",
  active_task_description: "Active task — description",
  tool_intent: "Tool-call intent",
  context_entity_id: "Attached context",
};

export const SEED_SOURCE_ORDER: KnowledgeGraphSeedSource[] = [
  "latest_user_message",
  "latest_assistant_message",
  "active_task_title",
  "active_task_description",
  "tool_intent",
  "context_entity_id",
];
